// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16A4V","title":"Header_title__3D3gz","left":"Header_left__1rxs1","clinicName":"Header_clinicName__19HdF"};